import { find } from 'lodash';
import moment from 'moment';
import {
	CalendarProvider,
	CalendarUtils,
	DateData,
	ExpandableCalendar,
	TimelineList,
} from 'react-native-calendars';
import { backgroundColor } from 'react-native-calendars/src/style';

function adjustColor(baseColor, index) {
	const adjustment = 12 * index; // Increase the adjustment factor
	const rgbComponents = baseColor
		.slice(4, -1)
		.split(',')
		.map((component) => parseInt(component.trim()) + adjustment);

	// Ensure the adjusted values are within the valid RGB range
	const adjustedColor = `rgb(${rgbComponents.map((c) =>
		Math.min(220, Math.max(0, c))
	)})`;

	return adjustedColor;
}

export default async function handleEventList(
	events: Array<any>,
	calendars,
	calendarType
) {
	const newMarkedDates = {};
	const calendarColors = new Map();

	const computeExpensiveValue = (fn) => {
		const cache = new Map();
		return (...args) => {
			const key = JSON.stringify(args);
			if (cache.has(key)) {
				return cache.get(key);
			}
			const result = fn(...args);
			cache.set(key, result);
			return result;
		};
	};

	// Memoized findColor function
	const findColor = computeExpensiveValue((id, index) => {
		const calendar = calendars.find(
			(item) => item.source?.id === id || item?.id === id || item._id === id
		);
		return calendar
			? calendar.color
			: adjustColor('rgb(90,192,234)', index);
	});

	try {
		events.forEach((item, index) => {
			// Memoized Calendar Color
			if (!calendarColors.has(item.calendarId)) {
				calendarColors.set(
					item.calendarId,
					findColor(item.calendarId, index)
				);
			}

			const adjustedColor =
				calendarColors.get(item.calendarId) || 'rgb(90,192,234)';
			const dateStringStart = CalendarUtils.getCalendarDateString(
				item.startDate
			);
			const dateStringEnd = CalendarUtils.getCalendarDateString(
				item.endDate
			);

			const initMarked = {
				id: item.id,
				marked: true,
				type: item.type,
				dotColor: 'green',
				color: adjustedColor,
				start: item.startDate,
				end: item.endDate,
				periods: [
					{
						startingDay: true,
						endingDay: true,
						color: adjustedColor,
						id: item.id,
					},
				],
			};

			// Memoized newMarkedDates population
			if (!newMarkedDates[dateStringStart]) {
				newMarkedDates[dateStringStart] = { ...initMarked };
			} else {
				newMarkedDates[dateStringStart].periods.push({
					startingDay: true,
					endingDay: true,
					color: adjustedColor,
					id: item.id,
				});
			}

			if (dateStringStart !== dateStringEnd) {
				if (!newMarkedDates[dateStringEnd]) {
					newMarkedDates[dateStringEnd] = { ...initMarked };
				}
				newMarkedDates[dateStringEnd].periods.push({
					startingDay: false,
					endingDay: true,
					color: adjustedColor,
					id: item.id || item._id,
				});
			}
		});
	} catch (error) {
		console.error(error);
		throw new Error(error);
	}

	return newMarkedDates;
}

